import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ReactElement, useState } from 'react';
import PropTypes from 'prop-types';
import {
	Headline5,
	Headline6,
	Subtitle2,
} from '../../../components/UI/MDC/Typography/Typography';
import classes from './WQAccordion.module.scss';
import classNames from 'classnames';

/**
 * Creates an accordion with drop down chevron to collapse/show
 *
 * @returns {ReactElement} rendered component.
 */
export const WQAccordion = ({
	title,
	subTitle,
	headerSize,
	defaultExpanded,
	coloredHeader,
	children,
	className,
}) => {
	const [expanded, setExpanded] = useState(defaultExpanded ?? true);
	const toggleExpanded = () => {
		setExpanded(!expanded);
	};

	const GetHeadline = (props, children) => {
		switch (headerSize) {
			case 5:
				return <Headline5 {...props}></Headline5>;
			default:
				return <Headline6 {...props}></Headline6>;
		}
	};
	return (
		<Accordion
			expanded={expanded}
			onChange={toggleExpanded}
			{...{ className }}
		>
			<AccordionSummary
				className={
					coloredHeader ? classNames(classes.coloredHeader) : null
				}
				expandIcon={
					<ExpandMoreIcon
						className={
							coloredHeader
								? classes['coloredHeader__color_white']
								: null
						}
					/>
				}
				aria-controls='panel1a-content'
				id='panel1a-header'
			>
				<div medium id={'Account-Administration'}>
					<GetHeadline
						className={
							coloredHeader
								? classes['coloredHeader__title']
								: classes['widget__title']
						}
					>
						{title}
					</GetHeadline>
					<Subtitle2 className={classes['widget__subtitle']}>
						{subTitle}
					</Subtitle2>
				</div>
			</AccordionSummary>
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
};
export const WQAccordionPropTypes = {
	title: PropTypes.string,
	subTitle: PropTypes.string,
	defaultExpanded: PropTypes.bool,
	coloredHeader: PropTypes.bool,
	headerSize: PropTypes.number,
};
